<template>
  <div class="container page" style="background-color: #f4f4f4;">
    <van-nav-bar title="充值记录" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#333" @click="back()" />
      </template>
      <template #right>
        <!-- <div style="font-size: 14px;padding-right: 10px;">筛选</div> -->
      </template>
    </van-nav-bar>
  
    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="rechargeList.length === 0" description="暂无记录" />
        
        <div v-else class="item_list" v-for="(v, key) in rechargeList" :key="key">
          <div class="topInfo">
            <span style="color: #333">
              {{ v.type==1?'充值':'彩金赠送' }}
            </span>
            
            <!-- 金额显示 -->
            <span style="float: right;color: #333;">
              金额：{{ v.money }}
            </span>
          </div>
          
          <!-- 时间显示 -->
          <div class="time">
            <span>充值时间：{{ v.create_time }}</span>
          </div>
          
          <div class="time">
            <span>说明：{{ v.desc }}</span>
          </div>
          
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      rechargeList: [],   // 充值记录
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    
    onRefresh() {
      this.loadRechargeList().then(() => {
        this.isLoading = false;
      }).catch(() => {
        this.isLoading = false;
      });
    },
    
    // 加载充值记录
    async loadRechargeList() {
      try {
        const res = await this.$http({
          method: 'get',
          url: 'user_get_recharge_list'
        });
        this.rechargeList=res.data
      } catch (error) {
        console.error('加载充值记录失败:', error);
      }
    },
  },
  
  created() {
    this.onRefresh()
  }
};
</script>
<style lang='less' scoped>
@import "../../assets/css/base.css";

::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}

.container .main{
  position: relative;
  overflow: auto;
  background-color: #f4f4f4;
  height: 100%;
  padding: 0 10px;
}

.item_list{
  padding: 15px 15px;
  margin: 20px 10px;
  background: #fff;
  border-radius: 10px;
  line-height: 60px;
  color: #333;
}

.item_list .topInfo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.item_list .topInfo span{
  font-size: 32px;
  font-weight: 700;
}

.item_list .time span{
  font-size: 25px;
  font-weight: 500;
  color: #333;
  line-height: 40px;
}
</style>